// extracted by mini-css-extract-plugin
export var image = "CollaborationCard-module--image--8998f";
export var root = "CollaborationCard-module--root--9811f";
export var title = "CollaborationCard-module--title--c7f13";